/** E.164-style input: optional leading +, then digits only. Spaces stripped. */
export function sanitizePhoneInput(value) {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  let rest = trimmed.replace(/\s/g, '');
  if (!rest) return '';
  let prefix = '';
  if (rest.startsWith('+')) {
    prefix = '+';
    rest = rest.slice(1);
  }
  const digits = rest.replace(/\D/g, '');
  return prefix + digits;
}

export const PHONE_MAX_LEN = 64;
